<script setup lang="ts">
import AppSvgIcon from '../appSvgIcon/AppSvgIcon.vue';
import AppRawButton from '../appRawButton/AppRawButton.vue';

interface AppAlternativeFilterButtonProps {
  activeFiltersAmount: number;
  type: 'secondary' | 'modern';
  compact: boolean;
  text: string;
  showFiltersAriaLabel: string;
}

const props = defineProps<AppAlternativeFilterButtonProps>();

interface AppAlternativeFilterButtonEmits {
  (eventName: 'click'): void;
}

const emit = defineEmits<AppAlternativeFilterButtonEmits>();
</script>

<template>
  <AppRawButton
    class="app-alternative-filter-button"
    :class="{ [props.type]: true }"
    :aria-label="props.showFiltersAriaLabel"
    @click="emit('click')"
  >
    <div v-if="props.activeFiltersAmount > 0" class="selected-filters-wrapper">
      <div class="circle" />
      <span class="selected-filters">
        {{ props.activeFiltersAmount }}
      </span>
    </div>
    <AppSvgIcon name="tune" size="18" />
    <div v-if="!props.compact && props.activeFiltersAmount === 0" class="text">
      {{ text }}
    </div>
  </AppRawButton>
</template>

<style scoped lang="scss">
@use '../../styles/_button-mixins.scss' as *;
@use '../../styles/media' as *;
@use '../../styles/fonts' as *;

.app-alternative-filter-button {
  padding: 7px 11px;
  gap: var(--spacing-4);
  @include button-base;

  &.secondary {
    @include button-type-secondary;
  }

  &.modern {
    @include button-type-modern;
  }

  .text {
    @include font-label-s-bold;
  }

  .selected-filters-wrapper {
    min-height: 20px;
    min-width: 20px;
    color: var(--color-white);
    position: relative;
    @include font-label-s-bold;

    .circle {
      position: absolute;
      top: 0;
      left: 0;
      background-color: var(--color-neutral-70);
      border-radius: var(--border-radius-30);
      height: 100%;
      aspect-ratio: 1/1;
    }

    .selected-filters {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
